export const HILTON_COMPANY_NAME = "Hilton";

export function isHiltonCompany(companyName?: string | null): boolean {
  return companyName?.trim().toLowerCase().includes(HILTON_COMPANY_NAME.toLowerCase()) ?? false;
}
